import PropTypes from 'prop-types'
import moment from 'moment'
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel
} from '@material-ui/core'

import {
  Input,
  Alerts,
  InputDate,
  MasterModal,
  InputSelect,
  InputDateTime
} from '~/components'

import Styled from './manage-modal.styled'
import useHooks from './manage-modal.hooks'
import { ConfirmAssignmentModal, ConfirmOverlapModal } from './components'

const ManageModal = (props) => {
  const isEdit = props.actionType === 'edit'
  const isView = props.actionType === 'view'
  const isCreate = props.actionType === 'create'

  const { data, methods } = useHooks(props)

  return (
    <>
      <MasterModal
        title='Vessel Forecast'
        isEdit={isEdit}
        maxWidth='lg'
        isDetail={true}
        subTitle={data.subTitle}
        fullWidth={true}
        showModal={props.showModal}
        handleSave={methods.handleSave}
        handleClose={methods.closeResetFormik}
        subSubTitle={data.isEdit || data.isView ? props.dataItem.SR_No : ''}
        isShowSaveButton={isEdit || isCreate}
        isVesselForecastModal={true}
        isSubmitButtonDisabled={
          data.isSubmitting || data.FormInput.isSubmitting
        }
      >
        <Styled.ColumnForm>
          <Styled.RowForm>
            <Styled.Form>
              <Styled.ContainerForm>
                <Styled.FormWrapper>
                  {(isEdit || isView) && (
                    <Input
                      form={data.FormInput}
                      type='text'
                      id='vf_manage_modal_sr_no'
                      label='Service Request No.'
                      name='SR_No'
                      placeholder='SRXXXXXXXXX'
                      inputProps={{
                        readOnly: true,
                        tabIndex: 1
                      }}
                    />
                  )}
                </Styled.FormWrapper>
                <Styled.FormWrapper>
                  {(isEdit || isView) && (
                    <FormControl component='fieldset'>
                      <FormLabel component='label' style={{ fontSize: 10 }}>
                        Vessel Assignment
                      </FormLabel>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id='vf_manage_modal_vessel_assignment'
                              form={data.FormInput}
                              name='Close_Assignment'
                              onChange={
                                isEdit && methods.handleChangeVesselAssignment
                              }
                              checked={data.FormInput.values.Close_Assignment}
                              tabIndex={1}
                              readOnly={isView}
                              disabled={isView}
                            />
                          }
                          label='Close Assignment'
                        />
                      </FormGroup>
                      <FormHelperText
                        style={{ visibility: 'hidden', margin: 0 }}
                      >
                        {data.FormInput.errors.Close_Assignment ||
                          'Close Assignment'}
                      </FormHelperText>
                    </FormControl>
                  )}
                </Styled.FormWrapper>
              </Styled.ContainerForm>
              <Styled.ContainerForm>
                <Styled.FormWrapper>
                  <InputSelect
                    id='vf_manage_modal_vessel_name'
                    label='Vessel Name'
                    name='Vessel_Name'
                    placeholder='Type at least 3 characters to search'
                    options={data.vesselOptions}
                    customAutocompleteProps={{
                      loading: data.vesselLoading,
                      onInputChange: (_, value) => methods.handleVesselSearch(value),
                      noOptionsText: 'Type at least 3 characters to search',
                      filterOptions: (x) => x,
                    }}
                    optionText='Vessel_Name'
                    optionValueKey='Code'
                    form={data.FormInput}
                    tabIndex={2}
                    readOnly={data.isView}
                  />
                </Styled.FormWrapper>
                <Styled.FormWrapper>
                  <InputSelect
                    id='vf_manage_modal_jetty'
                    label='Jetty'
                    name='Jetty'
                    placeholder='Jetty'
                    options={data.jettyOptions}
                    customAutocompleteProps={{
                      loading: data.loading
                    }}
                    optionText='Jetty_Name'
                    optionValueKey='Jetty_Code'
                    form={data.FormInput}
                    tabIndex={3}
                    readOnly={data.isView}
                  />
                </Styled.FormWrapper>
              </Styled.ContainerForm>
              <Styled.ContainerForm>
                <Styled.FormWrapper>
                  <InputSelect
                    id='vf_manage_modal_client'
                    label='Client'
                    name='Client'
                    placeholder='Client'
                    options={data.clientOptions}
                    customAutocompleteProps={{
                      loading: data.loading
                    }}
                    optionText='Customer_Name'
                    optionValueKey='SAP_Customer_No'
                    form={data.FormInput}
                    tabIndex={4}
                    readOnly={data.isView}
                  />
                </Styled.FormWrapper>
                <Styled.FormWrapper>
                  <InputSelect
                    id='vf_manage_modal_activity'
                    label='Activity'
                    name='Activity'
                    placeholder='Activity'
                    options={data.activityOptions}
                    customAutocompleteProps={{
                      loading: data.loading
                    }}
                    optionText='Value'
                    optionValueKey='Code'
                    form={data.FormInput}
                    tabIndex={5}
                    readOnly={data.isView}
                  />
                </Styled.FormWrapper>
              </Styled.ContainerForm>
              <Styled.ContainerForm>
                <Styled.FormWrapper>
                  <InputDateTime
                    fullWidth
                    className='date-time'
                    form={data.FormInput}
                    type='text'
                    id='vf_manage_modal_all_fast'
                    label='All Fast/Arrival'
                    name='All_Fast'
                    placeholder='All_Fast'
                    tabIndex={6}
                    readOnly={data.isView}
                  />
                </Styled.FormWrapper>
                <Styled.FormWrapper>
                  <InputDateTime
                    fullWidth
                    className='date-time'
                    form={data.FormInput}
                    type='text'
                    id='vf_manage_modal_cast_off'
                    label='Cast Off/Depart'
                    name='Cast_Off'
                    placeholder='Cast_Off'
                    tabIndex={7}
                    readOnly={data.isView}
                  />
                </Styled.FormWrapper>
              </Styled.ContainerForm>
              <Styled.ContainerForm>
                <Styled.FormWrapper>
                  <Input
                    form={data.FormInput}
                    type='text'
                    id='vf_manage_modal_duration'
                    label='Duration'
                    name='Duration'
                    placeholder='Duration'
                    value={data.FormInput.values.Duration || ''}
                    inputProps={{
                      tabIndex: 8,
                      readOnly: true
                    }}
                  />
                </Styled.FormWrapper>
                <Styled.FormWrapper>
                  <InputSelect
                    id='vf_manage_modal_status'
                    label='Status'
                    name='Status'
                    placeholder='Status'
                    options={data.statusOptions}
                    customAutocompleteProps={{
                      loading: data.loading
                    }}
                    optionText='Value'
                    optionValueKey='Code'
                    form={data.FormInput}
                    tabIndex={9}
                    readOnly={data.isView}
                  />
                </Styled.FormWrapper>
              </Styled.ContainerForm>
              <Styled.ContainerForm>
                <Styled.FormWrapper>
                  <Input
                    form={data.FormInput}
                    type='text'
                    id='vf_manage_modal_product'
                    label='Product'
                    name='Product'
                    placeholder='Product'
                    inputProps={{
                      tabIndex: 10,
                      readOnly: data.isView
                    }}
                  />
                </Styled.FormWrapper>
              </Styled.ContainerForm>
              <Styled.ContainerForm>
                <Styled.FormWrapper>
                  <Input
                    form={data.FormInput}
                    type='number'
                    id='vf_manage_modal_quantity'
                    label='Quantity'
                    name='Quantity'
                    placeholder='Quantity'
                    inputProps={{
                      tabIndex: 11,
                      readOnly: data.isView
                    }}
                  />
                </Styled.FormWrapper>
                <Styled.FormWrapper>
                  <InputSelect
                    id='vf_manage_modal_uom_code'
                    label='UOM Quantity'
                    name='UOM_Code'
                    placeholder='UOM Quantity'
                    options={data.uomQuantities}
                    customAutocompleteProps={{
                      loading: data.loading
                    }}
                    optionText='uom'
                    optionValueKey='code'
                    form={data.FormInput}
                    tabIndex={12}
                    readOnly={data.isView}
                  />
                </Styled.FormWrapper>
              </Styled.ContainerForm>
              <Styled.ContainerForm>
                <Styled.FormWrapper>
                  <InputDate
                    fullWidth
                    id='vf_manage_modal_laycan_start'
                    form={data.FormInput}
                    name='Laycan_Start'
                    label='Laycan Start'
                    tabIndex={13}
                    readOnly={data.isView}
                    placeholder='Laycan Start'
                    value={data.FormInput.values.Laycan_Start}
                    onChange={(value) =>
                      data.FormInput.setFieldValue('Laycan_Start', value)
                    }
                  />
                </Styled.FormWrapper>
                <Styled.FormWrapper>
                  <InputDate
                    fullWidth
                    id='vf_manage_modal_laycan_end'
                    form={data.FormInput}
                    name='Laycan_End'
                    label='Laycan End'
                    tabIndex={14}
                    readOnly={data.isView}
                    placeholder='Laycan End'
                    value={data.FormInput.values.Laycan_End}
                    onChange={(value) =>
                      data.FormInput.setFieldValue('Laycan_End', value)
                    }
                  />
                </Styled.FormWrapper>
              </Styled.ContainerForm>
            </Styled.Form>
          </Styled.RowForm>
          {(isEdit || isView) && (
            <Styled.BottomRowForm>
              <Styled.BottomForm>
                <Styled.Created>
                  Created by: {props.dataItem.created_by}
                </Styled.Created>
                <Styled.Created>
                  On:{' '}
                  {moment(props.dataItem.created_date).format(
                    'DD/MM/YYYY (HH:mm)'
                  )}
                </Styled.Created>
              </Styled.BottomForm>
              <Styled.BottomForm>
                <Styled.Modified>
                  Modified by: {props.dataItem.modified_by}
                </Styled.Modified>
                <Styled.Modified>
                  On:{' '}
                  {moment(props.dataItem.modified_date).format(
                    'DD/MM/YYYY (HH:mm)'
                  )}
                </Styled.Modified>
              </Styled.BottomForm>
            </Styled.BottomRowForm>
          )}
        </Styled.ColumnForm>
      </MasterModal>
      <Alerts
        msg={data.showAlert.msg}
        type={data.showAlert.type}
        open={data.showAlert.visible}
        close={methods.handleCloseAlert}
        success={data.showAlert.success}
      />

      {data.isOpenCofirmOverlap && (
        <ConfirmOverlapModal
          data={{
            isOpenCofirmOverlap: data.isOpenCofirmOverlap
          }}
          methods={{
            handleCloseForm: methods.handleCloseConfirmOverlap,
            handleConfrimOverlapData: methods.handleConfrimOverlapData,
            handleCloseConfirmOverlap: methods.handleCloseConfirmOverlap
          }}
        />
      )}

      {data.isOpenConfirmAssignment && (
        <ConfirmAssignmentModal
          data={{
            remarks: data.FormInput.values.Remarks_Vessel_Assignment || '',
            isOpenConfirmAssignment: data.isOpenConfirmAssignment
          }}
          methods={{
            handleUpdate: methods.handleSave,
            handleCloseForm: methods.handleCloseConfirmAssignment,
            handleChangeRemarks: methods.handleChangeRemarks
          }}
        />
      )}
    </>
  )
}

ManageModal.propTypes = {
  dataItem: PropTypes.object,
  showModal: PropTypes.bool.isRequired,
  dataState: PropTypes.object.isRequired,
  actionType: PropTypes.string.isRequired,
  refetchData: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired
}

export default ManageModal
